import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteGroup = (id) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.ADMIN.GROUP_MANAGEMENT.DELETE_GROUP(id)
  );
};

export default deleteGroup;
